namespace $ {

	export type $shm_hitalama_agent_provider_info = {
		title: string
		health_path: string
		token_required: boolean
		mcp_configurable: boolean
	}

}

namespace $.$$ {

	export class $shm_hitalama_agent_provider extends $mol_object2 {

		static infos(): Record< $shm_hitalama_agent_backend, $shm_hitalama_agent_provider_info > {
			return {
				opencode: {
					title: 'OpenCode',
					health_path: '/global/health',
					token_required: false,
					mcp_configurable: false,
				},
				dsh: {
					title: 'DSH harness',
					health_path: '/api/health',
					token_required: true,
					mcp_configurable: true,
				},
				codex: {
					title: 'Codex',
					health_path: '/health',
					token_required: false,
					mcp_configurable: true,
				},
			}
		}

		static normalize( value: unknown ): $shm_hitalama_agent_backend {
			return value === 'dsh' || value === 'codex' ? value : 'opencode'
		}

		static info( backend: $shm_hitalama_agent_backend ) {
			return this.infos()[ backend ]
		}

		static titles() {
			const infos = this.infos()
			return Object.fromEntries(
				Object.entries( infos ).map( ([ backend, info ])=> [ backend, info.title ] ),
			) as Record< $shm_hitalama_agent_backend, string >
		}

		static infer( url: string ): $shm_hitalama_agent_backend {
			try {
				const parsed = new URL( url, this.$.$mol_dom_context.document?.location.href )
				if( parsed.hostname === 'kikikuku.ru.tuna.am' ) return 'dsh'
				if( ( parsed.hostname === '127.0.0.1' || parsed.hostname === 'localhost' ) && parsed.port === '8080' ) return 'dsh'
			} catch( error ) {
				return 'opencode'
			}
			return 'opencode'
		}

		static url_default( backend: $shm_hitalama_agent_backend ) {
			const location = this.$.$mol_dom_context.document?.location
			if( backend === 'codex' ) {
				if( location?.protocol === 'https:' && location.hostname.includes( '158-160-195-195' ) ) {
					return 'https://codex.158-160-195-195.ip.hyoo.ru'
				}
				return 'http://127.0.0.1:4881'
			}
			if( backend === 'dsh' ) return location?.protocol === 'https:' && location.hostname.includes( '158-160-195-195' )
				? 'https://dsh-dev.158-160-195-195.ip.hyoo.ru' : 'http://127.0.0.1:8080'
			if( location?.protocol === 'https:' && location.hostname.includes( '158-160-195-195' ) ) {
				return 'https://opencode.158-160-195-195.ip.hyoo.ru'
			}
			return ''
		}

		static local_url_default( backend: $shm_hitalama_agent_backend ) {
			if( backend === 'codex' ) return 'http://127.0.0.1:4881'
			if( backend === 'dsh' ) return 'http://127.0.0.1:8080'
			return 'http://127.0.0.1:4096'
		}

		static mcp_url_default( backend: $shm_hitalama_agent_backend ) {
			// Existing custom DSH runtimes may use a different MCP daemon.
			if( backend === 'dsh' ) return ''
			const location = this.$.$mol_dom_context.document?.location
			if( backend !== 'opencode' && location?.protocol === 'https:' && location.hostname.includes( '158-160-195-195' ) ) {
				return 'wss://mcp-dev.158-160-195-195.ip.hyoo.ru/hitalama-mcp'
			}
			if( location?.protocol === 'https:' && location.hostname.startsWith( 'hitalama.' ) ) {
				return `wss://mcp.${ location.hostname.slice( 9 ) }/hitalama-mcp`
			}
			return 'ws://127.0.0.1:4817/hitalama-mcp'
		}

		static health_headers( backend: $shm_hitalama_agent_backend, token: string ) {
			if( !token ) return {} as Record< string, string >
			if( backend === 'dsh' ) return { 'Authorization': `Bearer ${ token }` }
			return { 'X-Hitalama-Agent-Token': token }
		}

		static api_headers( backend: $shm_hitalama_agent_backend, token: string ) {
			if( backend !== 'dsh' || !token ) return {} as Record< string, string >
			return { 'Authorization': `Bearer ${ token }` }
		}

		static health_message( backend: $shm_hitalama_agent_backend, health: any ) {
			if( backend === 'codex' && ( !health?.mcp?.configured || !health?.mcp?.ready ) ) return {
				ready: false,
				message: 'Codex доступен, но Hitalama MCP не подключён',
			}
			const runtime = health?.runtime
			const ready = runtime?.ready ?? health?.healthy ?? health?.ok
			const details = [ runtime?.provider, runtime?.model ].filter( Boolean ).join( ' / ' )
			if( ready ) return {
				ready,
				message: `Соединение установлено${ details ? `: ${ details }` : '' }`,
			}
			return { ready, message: 'Мост доступен, но рантайм не готов' }
		}

	}

}
